export enum SlateLayout {
  CLASSIC = 'CLASSIC',
  DEFAULT = 'DEFAULT',
  BASIC = 'BASIC',
  NO_HEADER = 'NO_HEADER',
}
